import CircularCheckmark from "../icons/CircularCheckmark";
import ProgressCircle from "../icons/ProgressCircle";
import { PanelNode } from "./panelUtils";

interface OptionPillsProps {
    panels: PanelNode[];
    activeIndex: number;
    fulfilledChildIds: string[];
    onSelect: (index: number) => void;
}

/** OPTION / OPTION_GROUP 的选项 pills。已满足显示对勾,否则在有单位要求时显示 completed/required。 */
export default function OptionPills({ panels, activeIndex, fulfilledChildIds, onSelect }: OptionPillsProps) {
    const fulfilledSet = new Set(fulfilledChildIds);
    return (
        <div className="mt-3">
            <div className="flex flex-wrap gap-1.5">
                {panels.map((panel, index) => {
                    const isActive = index === activeIndex;
                    const isFulfilled = fulfilledSet.has(panel.id);
                    const required = panel.rule.atLeastUnitsCount;
                    return (
                        <button
                            key={panel.id}
                            onClick={() => onSelect(index)}
                            className={`flex items-center gap-1 md:gap-1.5 px-2 py-1 md:px-3 md:py-1.5 rounded-full text-xs md:text-sm font-medium transition-colors whitespace-nowrap ${
                                isActive
                                    ? "bg-indigo-100 text-indigo-700"
                                    : "bg-gray-100 text-gray-500 hover:bg-gray-200 hover:text-gray-700"
                            }`}
                        >
                            <span>{panel.title}</span>
                            {isFulfilled ? (
                                <CircularCheckmark className="h-3 w-3 md:h-4 md:w-4 text-green-500" />
                            ) : required != null ? (
                                <ProgressCircle
                                    progress={required > 0 ? panel.summary.completedUnitsCount / required : 0}
                                    size={15}
                                    strokeWidth={2}
                                    showText={false}
                                    trackClassName={isActive ? "text-indigo-200" : "text-gray-300"}
                                />
                            ) : null}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
